import Layout from "../components/Layout";
import { Cobranza } from "../components/cobranzas";

const Cobranzas = () => {
	return (
		<>      
		<Layout/>
		<Cobranza/>
		</>
	);
}

export default Cobranzas; 